import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// NOTE: This is a helper function to help with conditional classes and class overrides.
// It ensures that only the required Tailwind classes are combined and sorted correctly.
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
